import ApiCallerClient, {ApiMethod} from "../clients/apiCallerClient";

export default class LLMAnswerGenerationClient {

    constructor(apiHost) {
        this.apiHost = apiHost;
    }

    getLLMAnswer = async (body) => {
        const path = `/prod`;
        return await ApiCallerClient.callApi({
            "endpoint": {
                "hostName": this.apiHost,
                "httpMethod": ApiMethod.POST,
                "path": path
            },
            "body": body
        });
    }
}